export default function fancyBox(){
    Fancybox.bind("[data-fancybox='video-about']", {
        Thumbs: {
            type: "classic",
        },
    });
    Fancybox.bind("[data-fancybox='gallery']", {
        Thumbs: {
            type: "classic",
        },
    });   
}
